import { LOGIN_URL } from '@/constants/environment';

/**
 * Redirects to login URL
 */
export function redirectToLogin(): void {
  const currentURL = window.location.href;

  window.location.href = `${LOGIN_URL}?redirect=${currentURL}`;
}
